// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"355402bb","268":"9523f00d","455":"d2c4ca94","551":"21f78d98","842":"b4fca6cf","879":"1ed8d9de","977":"4ebf15ee"}[chunkId] + ".chunk.js";
};